<template>
    <div class="FM_marketAccountList">
        <!-- 代理提现 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="withdrawalForm" class="demo-form-inline">
                <el-form-item>
                    <el-select size v-model="withdrawalForm.status" clearable placeholder="请选择当前状态">
                        <el-option label="待审核" value="1"></el-option>
                        <el-option label="通过" value="2"></el-option>
                        <el-option label="拒绝" value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button
                            size="medium"
                            type="primary"
                            icon="el-icon-search"
                            style="font-size: 12px;"
                            @click="handleSearch(withdrawalForm)"
                    >查询</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <el-table
                    :data="withdrawalTable"
                    size="mini"
                    border
                    style="width: 100%"
                    v-loading="loading"
            >

                <el-table-column
                        header-align="center"
                        align="center"
                        fixed
                        type="index"
                        label="ID"
                        min-width="80"
                ></el-table-column>
                <!-- 姓名 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="nickname"
                        label="姓名"
                        min-width="120"
                ></el-table-column>

                <!-- 充值金额 -->
                <el-table-column
                        header-align="center"
                        align="center"
                        prop="money"
                        label="充值金额"
                        min-width="200"
                ></el-table-column>

                <el-table-column
                        header-align="center"
                        align="center"
                        prop="pass_status"
                        label="当前状态"
                        min-width="120"
                        :formatter="formatStatus"
                ></el-table-column>

                <el-table-column
                        header-align="center"
                        align="center"
                        prop="create_time"
                        label="充值时间"
                        min-width="150"
                ></el-table-column>

                <!-- 操作 -->
                <el-table-column v-if="level==0"
                                 header-align="center"
                                 align="center"
                                 fixed="right"
                                 label="操作"
                                 min-width="150"
                >
                    <template slot-scope="scope">
                        <el-button
                                @click="handleInfo(scope.row)"
                                type="text"
                                size="small"
                                slot="reference"
                                v-if="level == 0"
                        >详情</el-button>&nbsp;
                        <!-- &lt;!&ndash; 撤销验证 &ndash;&gt; -->
                        <el-button
                                type="text"
                                size="small"
                                slot="reference"
                                @click="handleUndo(scope.row)"
                                v-if="scope.row.pass_status == 1"
                        >审核</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <paginations
                    :currentPage="page.currentPage"
                    :pageSize="page.pageSize"
                    :total="page.total"
                    @watchCurrent="getCurrent"
                    @watchPageSize="getPageSize"
            ></paginations>
        </el-card>
        <!-- 批量支付弹窗 -->
        <el-dialog :visible.sync="batchDialog" width="430px">
            <div class="batchTitle">
                <span>付款金额：</span>
                <span>{{batchInfo.payMoney.toFixed(2)}}&nbsp;元</span>
            </div>
            <div class="batchTitle">
                <span>付款笔数：</span>
                <span>{{batchInfo.payNum}}&nbsp;笔</span>
            </div>
            <div class="batchTitle">
                <span>付款费用：</span>
                <span>{{batchInfo.payCost.toFixed(2)}}&nbsp;元</span>
            </div>
            <el-divider></el-divider>
            <div class="batchTitle">
                <span>代付账户余额：</span>
                <span>{{batchInfo.payBalance}}&nbsp;元</span>
                <span class="batchTitle" style="margin-left:10px;">
                    <span>所需费用：</span>
                    <span>{{batchInfo.payCount.toFixed(2)}}&nbsp;元</span>
                </span>
            </div>
            <el-button
                    type="primary"
                    @click="submitBatch"
                    size="small"
                    :disabled="batchInfo.payButton"
            >确 定</el-button>
            <el-button @click="batchDialog = false" size="small">取 消</el-button>
        </el-dialog>
        <!-- 审核&详情 -->
        <info-audit
                v-if="infoIsShow"
                :infoIsShow="infoIsShow"
                :dialogData="dialogData"
                @infoClose="infoClose"
        ></info-audit>
    </div>
</template>

<script>
    import paginations from '../../../components/pagination/paginations';
    import infoAudit from './FM_marketAccountInfo';
    export default {
        name: "FM_marketAccountList",
        data() {
            return {
                level: sessionStorage.getItem('level'),
                isShowBatchPay: 0, //是否设置代付通道：0=否，1=是
                payRate: 0.071, //代付费率
                creatDate: '', //申请时间范围
                auditDate: '', //审核时间范围
                batchDialog: false, //批量代付弹窗
                infoIsShow: false, //审核弹窗
                dialogData: {
                    isInfo: null, //弹窗类型 1.详情 2.审核
                    data: {} //当前行的数据
                },
                batchList: [], //批量支付数据源
                batchInfo: {
                    batchReqData: [], //请求的id
                    payMoney: 0, //付款金额
                    payNum: 0, //付款笔数
                    payCost: 0, //付款费用
                    payBalance: 0, //代付账户余额
                    payCount: 0, //所需费用
                    payButton: false
                },
                withdrawalTable: [], //表格
                withdrawalForm: {
                    nickname: '',   //姓名
                    status: '',//当前状态
                    create_time: '',    //充值时间
                    page: 1,
                    limit: 10,
                },
                page: {
                    currentPage: 1, //当前页码
                    pageSize: 10, //条数
                    total: 0  //总数
                },
                loading: true,
                downLoading: false //导出loading
            }
        },
        mounted() {
            this.getData( //初始化
                this.withdrawalForm
            );
        },
        components: {
            paginations,
            infoAudit
        },
        methods: {
            typeChange(val) { //监听radio
                this.withdrawalForm.team_type = val;
                this.currentPage = 1; //重置分页
                this.withdrawalForm.page = 1; //重置
                // 表单提交
                this.getData();
            },
            handleSearch(withdrawalForm) {
                this.withdrawalForm.page = 1;
                this.page.currentPage = 1;
                // 表单提交
                this.getData();
            },

            handleInfo(row) { //详情
                this.infoIsShow = true;
                this.dialogData.isInfo = 1;
                this.dialogData.data = row;
            },
            handleUndo(row) { //审核
                this.infoIsShow = true;
                this.dialogData.isInfo = 2;
                this.dialogData.data = row;
                this.dialogData.data.isShowPayMethods = this.isShowBatchPay;
            },

            infoClose(ref) {
                this.infoIsShow = false;
                if (ref) {
                    this.getData();//刷新
                }
            },
            //分页
            getCurrent(page) {
                // 获取当前页修改的值
                this.page.currentPage = page;
                this.withdrawalForm.page = this.page.currentPage;
                this.withdrawalForm.limit = this.page.pageSize;
                this.getData();
            },
            getPageSize(limit) {
                this.page.currentPage = 1; //重置分页
                // 获取条数发生改变的值
                this.page.pageSize = limit;
                this.withdrawalForm.page = this.page.currentPage;
                this.withdrawalForm.limit = limit;
                this.getData();
            },
            getData() { //获取列表
                this.loading = true;
                this.$api.post("user/market_account_list",this.withdrawalForm,res => {
                    if (res.code == 0) {
                        let data = res.data;
                        this.page.total = data.count; //总数
                        this.withdrawalTable = data.list;
                    } else {
                        this.$message.error(res.msg);
                    }
                    //渲染结束后取消加载
                    this.loading = false;
                })
            },
            selectChange(val) { //多选发生改变时
                this.batchList = val;
            },
            formatStatus(row) { //格式化当前状态
                var status = '';
                switch (row.pass_status) {
                    case 1:
                        status = '待审核';
                        break;

                    case 2:
                        status = '通过';
                        break;

                    case 3:
                        status = '拒绝';
                        break;
                    default:
                        status = '';
                        break;
                }
                return status;
            },
        }
    };
</script>

<style lang="scss" scope>
    .FM_withdrawalList {
        .batchTitle {
            font-size: 12px;
            margin: 20px 0;
            :nth-child(1) {
                font-weight: 700;
                color: #1e1e1e;
            }
        }
        // .el-dialog__header {
        //     padding: 20px 20px 0px;
        // }
        .el-dialog__body {
            padding: 0px 20px 30px 20px;
        }
        // .el-input__inner {
        //     font-size: 12px;
        // }
        // .el-form-item {
        //     margin-bottom: 5px;
        // }
        .el-dialog {
            display: flex;
            flex-direction: column;
            margin: 0 !important;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            /*height:600px;*/
            max-height: calc(100% - 30px);
            max-width: calc(100% - 30px);
        }
        .el-dialog .el-dialog__body {
            flex: 1;
            overflow: auto;
        }
    }
</style>
